import styled, { css } from 'styled-components'
import { Container } from './Avatar'
import Breakpoints from '../../../widget/styles/breakpoints'

const StackedAvatars = styled.div<{ noBorder?: boolean, disableHide?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: all 0.2s ease-in-out;

  ${Container} {
    &:not(:first-child) {
      margin-left: -6px;

      @media screen and (max-width: ${Breakpoints.MOBILE}) {
        display: none;

        ${props => props.disableHide && css`
          display: flex;
        `}
      }
    }

    ${props => props.noBorder && css`
      box-shadow: none;
      border: none;
    `}
  }
`

export default StackedAvatars